import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Style-guide" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="nifty-UI-guide" transform="translate(-202.000000, -3111.000000)" fill={color}>
                <g id="Group-6" transform="translate(159.000000, 3068.000000)">
                    <path d="M62.8,67.3 L63.7003465,67.3 C64.6942677,67.3 65.5,68.0989567 65.5,69.1 C65.5,70.0941125 64.70131,70.9 63.7003465,70.9 L58.2996535,70.9 C57.3057323,70.9 56.5,70.1010433 56.5,69.1 C56.5,68.1058875 57.29869,67.3 58.2996535,67.3 L59.2,67.3 L59.2,61.9 L58.3053271,61.9 C57.3082725,61.9 56.5,61.1010433 56.5,60.1 C56.5,59.1058875 57.2978994,58.3 58.3053271,58.3 L60.9946729,58.3 C61.4961808,58.3 61.945471,58.5011282 62.2710699,58.8266925 C62.5986504,59.1510801 62.8,59.600369 62.8,60.1 L62.8,67.3 Z M61,79 C51.0588745,79 43,70.9411255 43,61 C43,51.0588745 51.0588745,43 61,43 C70.9411255,43 79,51.0588745 79,61 C79,70.9411255 70.9411255,79 61,79 Z M61,75.4 C68.9529004,75.4 75.4,68.9529004 75.4,61 C75.4,53.0470996 68.9529004,46.6 61,46.6 C53.0470996,46.6 46.6,53.0470996 46.6,61 C46.6,68.9529004 53.0470996,75.4 61,75.4 Z M61,56.5 C59.5088312,56.5 58.3,55.2911688 58.3,53.8 C58.3,52.3088312 59.5088312,51.1 61,51.1 C62.4911688,51.1 63.7,52.3088312 63.7,53.8 C63.7,55.2911688 62.4911688,56.5 61,56.5 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconInfo extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
